import { TypedDocumentNode, gql } from '@apollo/client';

import {
  coinBalancesFragment,
  commonCardMarketplaceFragment,
} from '@sorare/core/src/contexts/currentUser/queries';
import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import { RewardBoxDialogWithOnboarding } from 'components/rewards/RewardBoxDialogWithOnboarding';

import {
  ClaimFootballManagerTaskMutation,
  ClaimFootballManagerTaskMutationVariables,
} from './__generated__/useClaimManagerTask.graphql';

const CLAIM_FOOTBALL_MANAGER_TASK_MUTATION = gql`
  mutation ClaimFootballManagerTaskMutation(
    $input: claimFootballManagerTaskInput!
    $sport: Sport!
  ) {
    claimFootballManagerTask(input: $input) {
      currentUser {
        slug
        currentFootballRivalsManager {
          id
          remainingArenaRequests
        }
        baseballUserProfile {
          id
          dailyClaimTasks {
            id
            aasmState
            label
            readyAt
          }
        }
        ...CurrentUserProvider_coinBalances
        ...commonCardMarketplace_currentUser
      }
      footballManagerTask {
        id
        aasmState
        claimedAt
        probabilisticBundle {
          id
          config {
            id
            rarity
          }
          ...RewardBoxDialogWithOnboarding_probabilisticBundle
        }
        cards {
          slug
          pictureUrl
          rarityTyped
          anyPlayer {
            slug
            displayName
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
  ${RewardBoxDialogWithOnboarding.fragments.probabilisticBundle}
  ${coinBalancesFragment}
  ${commonCardMarketplaceFragment}
` as TypedDocumentNode<
  ClaimFootballManagerTaskMutation,
  ClaimFootballManagerTaskMutationVariables
>;

export const useClaimManagerTask = () => {
  return useMutation(CLAIM_FOOTBALL_MANAGER_TASK_MUTATION);
};
